<template>
  <div>
    <v-app-bar elevation="1" class="pr-4">
      <v-app-bar-nav-icon
        @click.stop="$emit('openDrawerClicked')"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>
        <v-img max-width="120" src="images/kmitl_logo.png"></v-img>
        <h3
          class="text-deep-orange mx-2"
          v-if="$vuetify.display.smAndUp"
        >
          {{ $t("app_bar.title") }}
        </h3>
      </v-toolbar-title>

      <!-- <v-spacer></v-spacer> -->

      <v-menu location="bottom" v-if="student_name">
        <template v-slot:activator="{ props }">
          <v-btn color="primary" variant="outlined" class="mr-3" v-bind="props">
            <span v-if="$vuetify.display.smAndUp">{{ student_name }}</span>
            <span v-else>{{ register_id }}</span>
            <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>
              <div class="text-center">
                {{ register_id }}
              </div>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <v-btn
                block
                variant="text"
                color="error"
                v-if="officer_name"
                @click="logoutSurrogatedStudent()"
              >
                logout
              </v-btn>
              <v-btn
                block
                variant="text"
                color="error"
                v-else
                @click="logout()"
              >
                logout
              </v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu location="bottom" v-if="officer_name">
        <template v-slot:activator="{ props }">
          <v-btn color="primary" variant="outlined" class="mr-3" v-bind="props">
            <span v-if="$vuetify.display.smAndUp">{{ officer_name }}</span>
            <span v-else>{{ officer_id }}</span>
            <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>
              <v-btn block variant="text" color="error" @click="logout()"
                >logout</v-btn
              >
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn
        color="primary"
        variant="outlined"
        class="mr-3"
        to="login"
        v-if="is_authen === false"
      >
        {{ $t("app_bar.login") }}
        <v-icon size="x-large">mdi-login</v-icon>
      </v-btn>

      <v-btn
        color="primary"
        variant="outlined"
        class="mr-3"
        @click="logout()"
        v-if="is_error"
      >
        Logout
        <v-icon size="x-large">mdi-logout</v-icon>
      </v-btn>

      <v-progress-circular
        indeterminate
        color="primary"
        class="mr-3"
        :width="3"
        v-if="is_authen === null && is_error === false"
      ></v-progress-circular>

      <LanguageButton />
    </v-app-bar>
  </div>
</template>

<script>
import LanguageButton from "./LanguageButton";

export default {
  components: {
    LanguageButton,
  },
  computed: {
    is_authen() {
      return this.$store.state.user.is_authen;
    },
    is_error() {
      return this.$store.state.user.is_error;
    },
    officer_id() {
      if (this.$store.state.user.is_officer && this.$store.state.user.user_info)
        return this.$store.state.user.user_info.payload.ticket.user_id;
      return null;
    },
    officer_name() {
      if (this.$store.state.user.is_officer && this.$store.state.user.user_info)
        return (
          (this.$store.state.user.user_info.fname_en != ""
            ? this.$store.state.user.user_info.fname_en
            : this.$store.state.user.user_info.fname_th) +
          " " +
          (this.$store.state.user.user_info.lname_en != ""
            ? this.$store.state.user.user_info.lname_en
            : this.$store.state.user.user_info.lname_th)
        );
      return null;
    },
    register_id() {
      if (this.$store.state.user.surrogated_student_info.APPLY_ID)
        return this.$store.state.user.surrogated_student_info.APPLY_ID;
      return null;
    },
    student_name() {
      if (this.$store.state.user.surrogated_student_info)
        return (
          (this.$store.state.user.surrogated_student_info.STUDENT_FNAME_EN != ""
            ? this.$store.state.user.surrogated_student_info.STUDENT_FNAME_EN
            : this.$store.state.user.surrogated_student_info.STUDENT_FNAME_TH) +
          " " +
          (this.$store.state.user.surrogated_student_info.STUDENT_LNAME_EN != ""
            ? this.$store.state.user.surrogated_student_info.STUDENT_LNAME_EN
            : this.$store.state.user.surrogated_student_info.STUDENT_LNAME_TH)
        );
      return null;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("user/logout");
    },
    logoutSurrogatedStudent() {
      this.$store.dispatch("user/logoutSurrogatedStudent");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-toolbar-title__placeholder) {
  display: flex;
  align-items: center;
}

.v-toolbar-title {
  h3 {
    margin-left: 10px;
    color: #e35205;
    font-weight: bold !important;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
